<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <a-config-provider :locale="getLocalConfigProvider()">
      <div v-if="id === null || id === undefined">
        <a-card class="m-wrong">
          <m-anim :options="notfound" class="anim" :height="getScreen ? 200 : 500"
            :width="getScreen ? 200 : 500"></m-anim>
          <h3>Not Found</h3>
          <p>
            Return to the previous page and make the selection manifest again!
          </p>
          <a-button type="primary" block>
            <router-link to="/mon-Tax/index">
              <a-icon type="rollback" />&nbsp; Return
            </router-link>
          </a-button>
        </a-card>
      </div>
      <div v-else>
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="loading">
              <div slot="title">
                SPT Manifest
                <small class="m-display-block m-text-small">{{
                  data.header.no_transaksi
                }}</small>
              </div>
              <div slot="extra">
                <a-button @click="handleRectification(id)" icon="form" :loading="printLoad.recti"
                  v-if="pembetulan_sts && pembetulan_sts != '0'">Rectification</a-button>
                <a-button @click="handleEdit(id)" icon="edit" type="danger" :loading="printLoad.manifest"
                  v-if="data.header.status && data.header.status != 'Release' && data.header.status != 'Done' && data.header.tlc_create == getAuth.username">Edit</a-button>
              </div>
              <!-- <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button-group type="dashed">
                    <a-button
                      @click="handlePrintManifest"
                      icon="printer"
                      :loading="printLoad.manifest"
                      >Manifest</a-button
                    >
                    <a-button
                      icon="printer"
                      @click="handlePrintSpk"
                      :loading="printLoad.spk"
                      >SPK</a-button
                    >
                  </a-button-group>
                </li>
                <li v-if="getAuth.username == data.header.user_pembuat">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.lastStatus == 'Revised' &&
                          getAuth.username == data.header.user_pembuat
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        !(
                          data.lastStatus == 'Revised' &&
                          getAuth.username == data.header.user_pembuat &&
                          data.canceled_sts
                        )
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover> -->

              <!-- <div class="m-card-body"> -->
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title">Date Create</span>
                  <span class="m-list-desc">{{ moment(data.header.date_create).format('DD-MM-YYYY') }}</span>
                </li>
                <li>
                  <span class="m-list-title">SPT Type</span>
                  <span class="m-list-desc">{{
                    data.header.jenis_spt
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Month-year</span>
                  <span class="m-list-desc">{{
                    data.header.bulan_tahun
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Remaining Value
                  </span>
                  <span class="m-list-desc">{{ formatCurrency('IDR', data.header.spt_value) }}<br />
                    <small :style="data.header.spt_value_label == 'Kurang Bayar' ? 'color:red' : 'color:green'"> ({{
                      data.header.spt_value_label }})</small>
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.header.note }}</span>
                </li>
              </ul>
              <!-- </div> -->
            </a-card>
            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">List tax Details</h4>
                <a-input-search v-model="search" placeholder="Quick Search" allowClear @change="searching"
                  class="margin-bottom" />
                <a-table :columns="columns" :data-source="data.tableData" :pagination="pagination"
                  :rowKey="(record, index) => { return index; }" size="small" bordered :scroll="{ x: 100 }">
                  <template slot="nomor" slot-scope="text, data, index">
                    <span>{{
                      (pagination.page - 1) * pagination.pageSize + index + 1
                    }}</span>
                  </template>
                  <template slot="notrans" slot-scope="data">
                    <a v-if="data.type != 'tax_verification'" @click="handlelinkNo(data)">
                      {{ data.no_trans }}
                    </a>
                    <span v-else>{{ data.no_trans }}</span>
                    <br />
                    <b><small>{{ data.type_label }}</small></b>
                  </template>
                  <template slot="tax_dt" slot-scope="text, data">
                    <b>{{ data.tax_type_label }}</b> /<br />
                    <span>{{
                      data.tax_date
                      ? moment(data.tax_date).format(getDefaultDateFormat)
                      : "-"
                    }}</span>

                  </template>
                  <template slot="value_dpp" slot-scope="text, data">
                    <div style="width:100%">
                      <span style="float:center">{{
                        formatCurrency("IDR", data.value_dpp)
                      }} /</span><br />
                      <span style="float:center">{{
                        formatCurrency("IDR", data.value)
                      }}</span>
                    </div>
                  </template>
                  <template slot="document_tax" slot-scope="text, data">
                    <div style="width:100%;text-align:center">
                      {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
                      <a-tooltip placement="bottomRight" title="View Document">
                        <a-button icon="file" size="small" type="link" v-if="!(
                          data.document_tax &&
                          data.document_tax == 'No File Uploaded'
                        )
                          " @click="handleviewAttacment(data)"></a-button>
                        <a-button v-else :disabled="true" size="small" type="link" icon="file"></a-button>
                      </a-tooltip>
                    </div>
                  </template>
                  <div slot="footer" v-if="data.header.jenis_spt && data.header.jenis_spt.includes('PPN')">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">PPN Keluaran Value (a)</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_ppn_keluaran" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">PPN Masukan Value (b)</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_ppn_masukan" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="16" :order="1" class="m-text-align left">
                        <a-divider class="margin-small"></a-divider>
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">Total (a-b)</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.total_ppn" />
                      </a-col>
                    </a-row>
                  </div>
                  <div slot="footer" v-if="data.header.jenis_spt && data.header.jenis_spt.includes('PPh21')">
                    <a-row type="flex">
                      <a-col :span="8" :order="1" class="m-text-align left">PPh 21 Salary Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph21_gaji" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="8" :order="1" class="m-text-align left">PPh 21 Commision Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph21_komisi" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="8" :order="1" class="m-text-align left">PPh 21 Saverance Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph21_pesangon" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="17" :order="1" class="m-text-align left">
                        <a-divider class="margin-small"></a-divider>
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="8" :order="1" class="m-text-align left">Total PPh 21</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.total_pph" />
                      </a-col>
                    </a-row>
                  </div>
                  <div slot="footer" v-if="data.header.jenis_spt && data.header.jenis_spt.includes('SPT Unifikasi')">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">PPh 4 (ayat 2) Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph_pasal4" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">PPh 22 Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph22" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">PPh 23 Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.nilai_pph23" />
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="16" :order="1" class="m-text-align left">
                        <a-divider class="margin-small"></a-divider>
                      </a-col>
                    </a-row>
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">Total Unifikasi Value</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.total_unifikasi" />
                      </a-col>
                    </a-row>
                  </div>
                </a-table>
              </a-collapse-panel>
            </a-collapse>

            <a-collapse class="margin-top" activeKey="1" v-if="tableDataTemp3.length > 0">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">List PBK</h4>
                <a-input-search v-model="search3" placeholder="Quick Search" allowClear @change="searching3"
                  class="margin-bottom" />
                <a-table :columns="columns3" :data-source="data.tableData3" :pagination="pagination3"
                  :rowKey="(record, index) => { return index; }" size="small" bordered :scroll="{ x: 100 }">
                  <template slot="nomor" slot-scope="text, data, index">
                    <span>{{
                      (pagination2.page2 - 1) * pagination2.pageSize + index + 1
                    }}</span>
                  </template>
                  <template slot="notrans" slot-scope="data">
                    <span @click="handlelinkNo(data)">{{ data.request_pbk_no }}</span>
                  </template>
                  <template slot="tax_dt" slot-scope="text, data">
                    <b>{{ data.jns_pajak_pemakaian_label }}</b> /<br />
                    <span>{{
                      data.masa_pajak_pemakaian_label
                      ? data.masa_pajak_pemakaian_label
                      : "-"
                    }}</span>

                  </template>
                  <template slot="val" slot-scope="text, data">
                    <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.value_req_pbk" />
                  </template>
                  <template slot="type" slot-scope="text, data">
                    <a-button @click="viewPBK(data.file_doc_pbk_path)" size="small">
                      View
                    </a-button>
                  </template>
                  <!-- <template slot="document_tax" slot-scope="text, data">
                <div style="width:100%;text-align:center">
                  {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
                  <a-tooltip
                    placement="bottomRight"
                    title="View Document"
                  >
                  <a-button
                    icon="file"
                    size="small"
                    type="link"
                    v-if="
                      !(
                        data.document_tax &&
                        data.document_tax == 'No File Uploaded'
                      )
                    "
                    @click="handleviewAttacment(data)"
                    ></a-button
                  >
                  <a-button v-else :disabled="true" size="small"
                  type="link"
                  icon="file"
                    ></a-button
                  >
                  </a-tooltip>
                </div>
              </template> -->
                  <div slot="footer">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">Total PBK</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.total_pbk" />
                      </a-col>
                    </a-row>
                  </div>
                </a-table>
              </a-collapse-panel>
            </a-collapse>

            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">List Compensation Details</h4>
                <a-input-search v-model="search2" placeholder="Quick Search" allowClear @change="searching2"
                  class="margin-bottom" />
                <a-table :columns="columns2" :data-source="data.tableData2" :pagination="pagination2"
                  :rowKey="(record, index) => { return index; }" size="small" bordered :scroll="{ x: 100 }">
                  <template slot="nomor" slot-scope="text, data, index">
                    <span>{{
                      (pagination2.page2 - 1) * pagination2.pageSize + index + 1
                    }}</span>
                  </template>
                  <template slot="notrans" slot-scope="data">
                    <span @click="handlelinkNo(data)">{{ data.spt_no }}</span>
                  </template>
                  <template slot="tax_dt" slot-scope="text, data">
                    <b>{{ data.jns_pajak_pemakaian_label }}</b> /<br />
                    <span>{{
                      data.masa_pajak_pemakaian_label
                      ? data.masa_pajak_pemakaian_label
                      : "-"
                    }}</span>

                  </template>
                  <template slot="val" slot-scope="text, data">
                    <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.value_kompensasi" />
                  </template>
                  <template slot="type" slot-scope="text, data">
                    {{ data.jns_kompensasi }}<br />
                    <a-button v-if="data.jns_kompensasi == 'PBK'" @click="viewPBK(data.file_doc_pbk_path)" size="small">
                      View
                    </a-button>
                  </template>
                  <!-- <template slot="document_tax" slot-scope="text, data">
                    <div style="width:100%;text-align:center">
                      {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
                      <a-tooltip
                        placement="bottomRight"
                        title="View Document"
                      >
                      <a-button
                        icon="file"
                        size="small"
                        type="link"
                        v-if="
                          !(
                            data.document_tax &&
                            data.document_tax == 'No File Uploaded'
                          )
                        "
                        @click="handleviewAttacment(data)"
                        ></a-button
                      >
                      <a-button v-else :disabled="true" size="small"
                      type="link"
                      icon="file"
                        ></a-button
                      >
                      </a-tooltip>
                    </div>
                  </template> -->
                  <div slot="footer">
                    <a-row type="flex">
                      <a-col :span="7" :order="1" class="m-text-align left">Total Compensation</a-col>
                      <a-col :span="1" :order="2" class="m-text-align left">
                      </a-col>
                      <a-col :span="8" :order="3" class="m-text-align left">
                        <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.total_kompensasi" />
                      </a-col>
                    </a-row>
                  </div>
                </a-table>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-card :class="getScreen ? 'margin-top' : ''">
              <div slot="title">Evidence of Transfer</div>
              <div>
                <a-alert v-if="data.bukti_transfer.length <= 0" type="error"
                  message="No evidence of transfer was uploaded" banner />
                <a-list itemLayout="horizontal" :dataSource="data.bukti_transfer" v-else>
                  <Empty v-if="data.bukti_transfer
                    ? data.bukti_transfer.length <= 0
                    : data.bukti_transfer
                    " />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div slot="title" class="m-display-flex space-between">
                        <h3 class="margin-remove">
                          {{ moment(item.tgl_tf).format(getDefaultDateFormat) }}
                        </h3>


                        <h4 class="margin-remove">
                          {{ formatCurrency(data.mata_uang, item.value_tf) }}
                        </h4>
                      </div>
                      <img class="m-image-icon" slot="avatar" :src="$serviceUrl + item.url" />\
                      <p slot="description" class="margin-remove">
                        {{ item.user_tf }}
                        <br />
                        <a-button @click="handleViewDt(item)" size="small" type="default" icon="eye">View</a-button>
                      </p>

                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </div>
            </a-card>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div class="m-display-flex space-between align-middle" slot="header">
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="data.header.status" />
                    <!-- <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button> -->
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">{{ moment(data.header.date_create).format('DD-MM-YYYY') }}</h4>
                      <span class="m-text-small" v-if="data.header.note">{{
                        data.header.note
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item v-for="workflow in data.status" :key="workflow.step_no">
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                        {{
                          moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                        }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div class="m-display-flex space-between align-middle" slot="header">
                  <h4 class="margin-remove">SPT Supporting Document</h4>
                  <!-- <a-button type="primary" size="small" style="margin-right: 10px;" @click="toUploadModal"
                    v-if="data.header.status && data.header.status.toLowerCase() == 'release'">Upload</a-button> -->
                  <a-button type="primary" size="small" style="margin-right: 10px;" @click="toUploadModal"
                    v-if="istaxOfficer">Upload</a-button>
                </div>
                <!-- <a-button class="margin-bottom" @click="toUploadModal('upload')"> <a-icon type="upload"/>Upload Doc </a-button>
              <a-divider class="margin-small"></a-divider> -->
                <a-list itemLayout="horizontal" :data-source="data.dokumen_pendukung">
                  <Empty v-if="data.dokumen_pendukung
                    ? data.dokumen_pendukung.length <= 0
                    : data.dokumen_pendukung
                    " />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div slot="title" class="m-display-flex space-between align-middle">
                        <span @click="handleView(item)">{{ item.type_doc }}</span>
                      </div>
                      <div slot="description">
                        <div class="m-width-full">
                          <a-tooltip class="ant-tooltip-inner" placement="top" :title="item.description
                            ? item.description
                            : 'Tidak ada deskripsi'
                            ">
                            <span class="ant-description-ellipses">{{
                              item.description
                              ? item.description
                              : "Tidak ada deskripsi"
                            }}</span>
                          </a-tooltip>
                        </div>
                        <a @click="handleViewDt({ url: item.file_path })"><span>{{ item.file_nm }}</span></a>
                      </div>
                      <div slot="title" v-if="item.value_transaksi && item.rest_api !== 'sppds'">
                        <span class="m-timeline-title">{{
                          formatCurrency(item.currency, item.value_transaksi)
                        }}</span>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div class="m-display-flex space-between align-middle" slot="header">
                  <h4 class="margin-remove">Pembetulan SPT</h4>
                </div>
                <a-list itemLayout="horizontal" :data-source="data.pembetulan_spt">
                  <Empty v-if="data.pembetulan_spt
                    ? data.pembetulan_spt.length <= 0
                    : data.pembetulan_spt
                    " />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div slot="title" class="m-display-flex space-between align-middle">
                        <a @click="handleViewManifest(item)">{{ item.spt_no }}</a>
                      </div>
                      <div slot="description">
                        <div class="m-width-full">
                          <span>{{
                            item.spt_type_label
                            ? (item.spt_type_label + ' | ' + item.spt_masa_label)
                            : "Tidak ada deskripsi"
                          }}</span>
                          <div><span class="margin-remove">{{ moment(item.date_create).format(getDefaultDateFormat)
                          }}</span></div>
                          <Status :status="item.spt_status"></Status>
                        </div>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :class="getScreen ? 'margin-bottom margin-top' : 'margin-top'" :loading="loading"
              v-if="data.header.status && data.header.status.toLowerCase() != 'revised' && data.header.status.toLowerCase() != 'done' && data.jenis != 'Transfer' && data.aksi.length > 0">
              <div slot="title">Manifest actions</div>

              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea placeholder="Write the note here ... " :rows="4" v-decorator="['remark']" />
                </a-form-item>
                <a-form-item label="Action">
                  <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button @click="handleActionApproval" block type="primary" html-type="submit"
                    :loading="loadingApproval">Save</a-button>
                </a-form-item>
              </a-form>
            </a-card>
            <a-card class="margin-top" v-if="data.jenis == 'Transfer'">
              <div slot="title">
                Manifest Actions &nbsp;
              </div>
              <div class="m-text-align right margin-remove" slot="extra">
                <h5 class="m-text-align right margin-remove">
                  remaining balance
                </h5>
                <a-tag color="green" class="m-text-align right margin-remove">{{
                  formatCurrency("IDR", sisa_tf)
                }}</a-tag>
              </div>
              <div>
                <a-form :form="formTransfer">
                  <a-form-item label="Status">
                    <a-select @change="onChangeStatus" v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]">
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{ da.aksi }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker placeholder="Select Date" :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true },], initialValue: moment() }]" />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload :fileList="fileList" :disabled="fileList.length > 0" v-decorator="[
                      'file_transfer',
                      { rules: [{ required: reqFileTf }] },
                    ]" accept=".jpg, .png, .pdf" :remove="handleRemove" :beforeUpload="beforeUpload">
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox :defaultChecked="true" @change="onchangeNilaiTf" :checked="checkTransferValue">Transfer
                      value according to remaining balance</a-checkbox>
                    <a-input-number :min="0.1" :max="sisa_tf" v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: temp_sisa_tf,
                      },
                    ]" :disabled="disableNilaiTf" class="m-width-full m-text-align-right"
                      :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea placeholder="Write the note here ... " :rows="4"
                      v-decorator="['catatan', { rules: [{ required: false }] }]" />
                  </a-form-item>
                  <a-form-item :wrapper-col="{ span: 24 }">
                    <a-button @click="handleActionConfirm" block type="primary" html-type="submit"
                      :loading="loadingApproval">Save</a-button>
                  </a-form-item>
                </a-form>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          </a-col>
        </a-row>
      </div>
    </a-config-provider>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="  history   in   data.history  " :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title" v-if="history.aksi === '4' && history.deskripsi === 'Edited'">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="visibleuploadDoc" width="70%" :footer="null">
      <span slot="title"> <a-icon type="upload" /> Upload Document</span>

      <div>
        <a-card>
          <a-form :form="formUpload" id="form">
            <a-row :gutter="16">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Description">
                  <a-input v-decorator="['description', {
                    rules: [{ required: true }],
                    initialValue: null,
                  }]
                    "></a-input>
                </a-form-item>
                <a-form-item label="Document Function">
                  <a-select showSearch v-decorator="['fungsi_document', { rules: [{ required: true }] }]">
                    <a-select-option key="DOC SSP">DOC SSP</a-select-option>
                    <a-select-option key="DOC SPT">DOC SPT</a-select-option>
                    <a-select-option key="DOC ID Billing">DOC ID Billing</a-select-option>
                    <a-select-option key="Other">Other</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item label="Select Document">
                  <a-upload :showUploadList="false" :beforeUpload="beforeUploadDoc"
                    v-decorator="['upload', { valuePropName: 'push' }]" :disabled="loadingmodal.upload">
                    <a-button>
                      <a-icon :type="loadingmodal.upload ? 'loading' : 'upload'" />&nbsp;Select File
                    </a-button>
                  </a-upload>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-card class="margin-top">
                  <span slot="title">Supporting Documents</span>
                  <a-list item-layout="horizontal" :data-source="data.dokumen_pendukung">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta>
                        <div slot="avatar">
                          <a-icon :type="load_icon(typeFileFromName(item.file_nm))" style="font-size: 48px" />
                        </div>
                        <div slot="description">
                          <a-row :gutter="6">
                            <a-col :xs="{ span: 12 }" :lg="{ span: 21 }">
                              <a-tooltip class="m-tooltip-inner" placement="top"
                                :title="'[' + item.type_doc + '] ' + item.description">
                                <h4 class="margin-remove m-text-dots">
                                  [{{ item.type_doc }}] {{ item.description }}
                                </h4>
                              </a-tooltip>
                              <a-tooltip class="m-tooltip-inner" placement="top" :title="item.file_nm">
                                <span class="margin-remove m-text-dots">
                                  <a @click="handleViewDt({ url: item.file_path })">{{ item.file_nm }}</a>
                                </span>
                              </a-tooltip>
                            </a-col>
                            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
                              <div style="height:100%">
                                <a-button type="danger" icon="delete"
                                  :loading="loadingmodal.remove && item.spt_doc_id == loadingmodal.key"
                                  @click="removeUploadFile(item.spt_doc_id)"></a-button>
                              </div>
                            </a-col>
                          </a-row>
                        </div>
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                </a-card>
              </a-col>
            </a-row>
          </a-form>
        </a-card>
      </div>
    </a-modal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/notfound.json";
import Status from "@/components/Status.vue";
import Axios from "axios";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod";

export default {
  name: "manifest",
  props: { id: String, tipe: String, },
  components: { "m-anim": lottie, Status },
  mixins: [HandleRoute, CurrencyFormat, GlobalMethod],
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsSpecialMenu",
      "getStandartFormatDate",
      "getDateTimeFormat",
      "getDefaultDateFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "no",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "nomor" },
        },
        {
          title: "No.Transaction",
          width: 300,
          key: "notrans",
          scopedSlots: { customRender: "notrans" },
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_date",
          align: "center",
          scopedSlots: { customRender: "tax_dt" },
          width: 150,
        },
        {
          title: "DPP / Tax Value",
          key: "value_dpp",
          align: "center",
          scopedSlots: { customRender: "value_dpp" },
          width: 150,
        },
        {
          title: "Status Document",
          key: "document_tax",
          align: "center",
          scopedSlots: { customRender: "document_tax" },
          width: 200,
        },
      ];
      return kolom;
    },
    columns2() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "no",
          width: 30,
          align: "center",
          scopedSlots: { customRender: "nomor" },
        },
        {
          title: "No.Transaction",
          width: 250,
          key: "notrans",
          scopedSlots: { customRender: "notrans" },
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_date",
          align: "center",
          scopedSlots: { customRender: "tax_dt" },
          width: 150,
        },
        {
          title: "Value",
          key: "val",
          align: "center",
          scopedSlots: { customRender: "val" },
          width: 150,
        },
        {
          title: "Type",
          key: "type",
          align: "center",
          scopedSlots: { customRender: "type" },
          width: 200,
        },
      ];
      return kolom;
    },
    columns3() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "no",
          width: 30,
          align: "center",
          scopedSlots: { customRender: "nomor" },
        },
        {
          title: "No.Transaction",
          width: 250,
          key: "notrans",
          scopedSlots: { customRender: "notrans" },
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_date",
          align: "center",
          scopedSlots: { customRender: "tax_dt" },
          width: 150,
        },
        {
          title: "Value",
          key: "val",
          align: "center",
          scopedSlots: { customRender: "val" },
          width: 200,
        },
        {
          title: "Document",
          key: "type",
          align: "center",
          scopedSlots: { customRender: "type" },
          width: 100,
        },
      ];
      return kolom;
    },
    istaxOfficer() {
      return _.filter(this.getAuth.nama_bidang, (e) => e.toLowerCase() == "tax officer").length > 0 ? true : false
    }
  },
  data() {
    return {
      loading: true,
      printLoad: {
        manifest: false,
        spk: false,
        cancel: false,
        recti: false,
      },
      notfound: { animationData: notfound, loop: true },
      id_sppd: this.id,
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 5,
        page: 1,
        size: "small",
      },
      pagination2: {
        onChange: (page) => {
          this.pagination.page2 = page;
        },
        pageSize: 5,
        page2: 1,
        size: "small",
      },
      pagination3: {
        onChange: (page) => {
          this.pagination.page3 = page;
        },
        pageSize: 5,
        page3: 1,
        size: "small",
      },
      data: {
        header: [],
        assignee: [],
        lastStatus: "",
        mengetahui: [],
        history: [],
        workflowStatus: [],
        jenis: "",
        aksi: null,
        dokumen_pendukung: [],
        bukti_transfer: [],
        tableData: [],
        tableData2: [],
        tableData3: [],
      },
      visibleHistory: false,
      visibleuploadDoc: false,
      search: "",
      search2: "",
      search3: "",
      canceled_sts: false,
      tableDataTemp: [],
      tableDataTemp2: [],
      tableDataTemp3: [],
      pembetulan_sts: false,
      modalUploadnote: null,
      loadingmodal: {
        upload: false,
        remove: false,
        key: null,
        tipe: null,
      },
      loadingApproval: false,
      sisa_tf: 0,
      temp_sisa_tf: "",
      aksiSelected: "",
      fileList: [],
      tglTf: moment(new Date()),
      dateFormat: "DD-MM-YYYY",
      checkTransferValue: true,
      disableNilaiTf: true,
      cek_value: 1,
      catatan: "",
      reqFileTf: true,
    };
  },
  mounted() {
    this.fetchManifest(this.id);
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
  },
  watch: {
    id() {
      if (this.id) {
        this.id_sppd = this.id;
        this.fetchManifest(this.id);
      }
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formTransfer = this.$form.createForm(this);
    this.formUpload = this.$form.createForm(this);
  },
  beforeRouteUpdate(to, from, next) {
    this.fetchManifest(to.params.id);
    next();
  },
  methods: {
    moment,
    async fetchManifest(idValue) {
      this.loading = true;

      await Axios({
        method: "get",
        url: this.$serviceUrl + "spt/manifest",
        params: {
          spt_id: idValue,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          //console.log(response)
          this.data.header = response.data.header;
          this.data.dokumen_pendukung = response.data.dokumen_pendukung;
          this.data.pembetulan_spt = response.data.pembetulan_spt;
          this.data.tableData = response.data.list_tax_detail;
          this.tableDataTemp = this.data.tableData;
          this.data.tableData2 = response.data.list_details_kompensasi;
          this.tableDataTemp2 = this.data.tableData2;
          this.data.tableData3 = response.data.list_details_pbk;
          this.tableDataTemp3 = this.data.tableData3;
          this.data.status = response.data.status_app;
          this.data.aksi = response.data.aksi
          this.data.jenis = response.data.jenis
          this.data.bukti_transfer = response.data.bukti_transfer ? response.data.bukti_transfer : []

          this.sisa_tf = response.data.saldo;
          this.temp_sisa_tf = response.data.saldo;

          this.data['nilai_ppn_keluaran'] = response.data.nilai_ppn_keluaran;
          this.data['nilai_ppn_masukan'] = response.data.nilai_ppn_masukan;
          this.data['total_ppn'] = response.data.total_ppn;
          this.data['total_kompensasi'] = response.data.total_kompensasi;

          this.data['nilai_pph21_gaji'] = response.data.nilai_pph21_gaji;
          this.data['nilai_pph21_komisi'] = response.data.nilai_pph21_komisi;
          this.data['nilai_pph21_pesangon'] = response.data.nilai_pph21_pesangon;
          this.data['total_pph'] = response.data.spt_tax_value;

          this.data['nilai_pph22'] = response.data.nilai_pph22;
          this.data['nilai_pph23'] = response.data.nilai_pph23;
          this.data['nilai_pph_pasal4'] = response.data.nilai_pph_pasal4;
          this.data['total_unifikasi'] = response.data.spt_tax_value;
          

          this.data['total_pbk'] = response.data.total_pbk ? response.data.total_pbk : 0;

          this.pembetulan_sts = response.data.pembetulan_sts;

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("choose-again");
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        axios({
          method: "put",
          url: this.$serviceUrl + "sppds/approval ",
          processData: false,
          data: {
            id_sppd: this.id_sppd,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan_sppds ? values.catatan_sppds : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds/cetakmanifest",
        responseType: "blob",
        params: {
          id_sppd: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlePrintSpk() {
      this.printLoad.spk = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds/cetakspk",
        responseType: "blob",
        params: {
          id_sppd: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.spk = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.spk = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "sppds",
        id_manifest: this.id,
        code_trans: this.data.header.no_sppd,
        kode_project: this.data.header.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "SPTEdit",
        params: { id: this.id, tipe: "revised" },
      });
    },
    handlelinkNo(item) {
      item.rest_api = item.type.toLowerCase();
      item.id_manifest = item.id_transaction;
      item.user_pembuat = item.tlc;
      item.tab = "release";
      item.jns = "Penerimaan_Kontrak";
      item.jenis = "Penerimaan_Kontrak";
      this.handleView(item, true);
    },
    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    searching() {
      if (this.search) {
        let tdt = this.tableDataTemp
        this.data.tableData = tdt.filter(
          (obj) =>
            obj.no_trans &&
            obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.type_label &&
            obj.type_label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tax_type_label &&
            obj.tax_type_label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0,
        );
      }

      if (!this.search) {
        this.data.tableData = this.tableDataTemp;
      }

      //return this.data.tableData;
    },
    searching2() {
      if (this.search2) {
        let tdt = this.tableDataTemp2;
        this.data.tableData2 = tdt.filter(
          (obj) =>
            (obj.spt_no &&
              obj.spt_no.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0) ||
            (obj.jns_pajak_pemakaian_label &&
              obj.jns_pajak_pemakaian_label.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0) ||
            (obj.jns_pajak_pemakaian &&
              obj.jns_pajak_pemakaian.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0) ||
            (obj.masa_pajak_pemakaian_label &&
              obj.masa_pajak_pemakaian_label.toLowerCase().indexOf(this.search2.toLowerCase()) >= 0)
        );
      } else {
        this.data.tableData2 = this.tableDataTemp2;
      }

      //return this.data.tableData2;
    },
    searching3() {
      if (this.search3) {
        let tdt = this.tableDataTemp3;
        this.data.tableData3 = tdt.filter(
          (obj) =>
            (obj.request_pbk_no &&
              obj.request_pbk_no.toLowerCase().indexOf(this.search3.toLowerCase()) >= 0) ||
            (obj.jns_pajak_pemakaian_label &&
              obj.jns_pajak_pemakaian_label.toLowerCase().indexOf(this.search3.toLowerCase()) >= 0) ||
            (obj.masa_pajak_pemakaian_label &&
              obj.masa_pajak_pemakaian_label.toLowerCase().indexOf(this.search3.toLowerCase()) >= 0)
        );
      } else {
        this.data.tableData3 = this.tableDataTemp3;
      }
    },
    viewPBK(url) {
      window.open(this.$serviceUrl + url);
    },
    handleViewManifest(item) {
      this.$router.push({
        name: "SPTManifest",
        params: { id: item.spt_id, tipe: item.spt_type },
      });
    },
    handleRectification(id) {
      this.printLoad.recti = true;
      this.asyncAxiosPost("spt/pembetulan", "application/json", this.getAuth, { spt_id: id })
        .then((res) => {
          this.printLoad.recti = false;
          this.$router.push({
            name: "SPTEdit",
            params: { id: res.spt_id },
          })
        })
        .catch((err) => {
          this.printLoad.recti = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    toUploadModal(e) {
      this.visibleuploadDoc = true;
      //this.loadingmodal.tipe = val;
      e.stopPropagation();
    },
    beforeUploadDoc(file) {
      this.formUpload.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const FileSize = file.size / 1024 / 1024;
        if (FileSize > 10) {
          this.displayMessage("large-file-10mb");
        } else {
          this.loadingmodal.upload = true;
          let data = new FormData();
          data.append("spt_id", this.id);
          data.append("description", values.description);
          data.append("document_function", values.fungsi_document);
          data.append("upload_document_file", file);
          this.asyncAxiosPost("spt/document_spt", "formdata", this.getAuth, data)
            .then(() => {
              // this.data.dokumen_pendukung.push(res.data);
              this.fetchManifest(this.id)
                .then(() => {
                  this.formUpload.resetFields();
                  this.loadingmodal.upload = false;
                });
            })
            .catch((err) => {
              this.loadingmodal.upload = false;
              Event.$emit("disableNext", false);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        }
      });
      return false;
    },
    removeUploadFile(index) {
      this.loadingmodal.remove = true;
      this.loadingmodal.key = index;
      this.asyncAxiosDelete(
        "spt/document_spt",
        "application/json",
        this.getAuth,
        {
          spt_id: this.id,
          spt_doc_id: index
        }
      )
        .then(() => {
          this.fetchManifest(this.id)
            .then(() => {
              this.loadingmodal.remove = false;
              this.loadingmodal.key = "";
            });
        })
        .catch((err) => {
          console.log(err);
          this.loadingmodal.remove = false;
          this.loadingmodal.key = "";
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handleActionApproval() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        // if (values.aksi == "Verified" && this.data.dokumen_pendukung.length == 0) {
        //   this.displayMessageValue("error-other", "Supporting Document Can't Be Empty!");
        //   return;
        // }

        let post = new FormData();
        post.append("id_manifest", this.id);
        post.append("status", values.aksi);
        post.append("remark", values.remark ? values.remark : "");

        this.loadingApproval = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "spt/approval",
          processData: false,
          data: post,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then(() => {
            this.loadingApproval = false;
            this.displayMessage("success");
            this.fetchManifest(this.id);
          })
          .catch((err) => {
            this.loadingApproval = false;
            console.log(err);
            this.loading.cancel = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });
      });
    },
    onChangeStatus(val) {
      // this.aksiSelected = val;
      // if (val === "Revised") {
      //   this.fileList = [];
      // }
      if (val === "Revised") {
        this.reqFileTf = false;
        this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        });
      } else if (val === "Transferred") {
        this.reqFileTf = true;
        this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        });
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        this.fileList.push(file);
        return false;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.$nextTick(() => {
          this.formTransfer.setFieldsValue({ value_transferan: this.sisa_tf });
        });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    submitConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleActionConfirm() {
      const that = this;
      that.formTransfer.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.$confirm({
          title: "Are you sure to Transfer?",
          content: null,
          okText: "Yes",
          cancelText: "No",
          onOk() {
            let post = new FormData();
            if (that.aksiSelected === "Revised") {
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append("tlc", that.getAuth.username);
              post.append("id_manifest", that.data.header.spt_id);
            } else {
              post.append("id_manifest", that.data.header.spt_id);
              post.append("tlc", that.getAuth.username);
              post.append("status", values.status);
              post.append("remark", values.remark ? values.remark : "");
              post.append(
                "tgl_tf", moment(values.tgl_trf).format(that.getStandartFormatDate)
              );
              post.append("value_transferan", values.value_transferan);
              post.append("file_transfer", that.fileList[0]);
            }

            that.loadingApproval = true;
            axios({
              method: "post",
              url: that.$serviceUrl + "spt/approval ",
              processData: false,
              data: post,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(() => {
                that.loadingApproval = false;
                that.displayMessage("success");
                that.$router.go();
              })
              .catch((err) => {
                that.loadingApproval = false;
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  that.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  that.displayMessageValue("error", responses);
                }
              });
          },
          onCancel() { },
        });
      });
    },
    handleViewDt(file) {
      window.open(this.$serviceUrl + file.url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped></style>
